import React, { useCallback, useEffect, useState } from 'react';
import { postman } from '../../utils/postman';
import './style.scss';

const PoolingLogo = () => (
    <svg className="pm-logo" viewBox="0 0 18 18" aria-hidden="true">
        <circle cx="4.5" cy="4.5" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="13.5" cy="4.5" r="3.8" fill="currentColor" />
        <circle cx="4.5" cy="13.5" r="3.8" fill="currentColor" />
        <circle cx="13.5" cy="13.5" r="3.8" fill="currentColor" />
    </svg>
);

const openEpdUrl = (url, e) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const PoolingEpdBadge = ({ url }) => {
    if (!url) {
        return null;
    }

    return (
        <a
            className="pm-badge"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => openEpdUrl(url, e)}
        >
            <PoolingLogo />
            Подписать ЭПД за 1 минуту
        </a>
    );
};

export const PoolingEpdToast = ({ shippingId, url, visible }) => {
    const [open, setOpen] = useState(Boolean(visible));

    useEffect(() => {
        setOpen(Boolean(visible));
    }, [visible, shippingId]);

    const dismiss = useCallback(() => {
        setOpen(false);
        if (shippingId) {
            postman.post(`shippings/${shippingId}/dismissEpdBanner`).catch(() => {});
        }
    }, [shippingId]);

    if (!open || !url) {
        return null;
    }

    return (
        <div className="pm-toast" role="dialog" aria-labelledby="pm-toast-title">
            <div className="pm-toast__top">
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#146c3b"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M8 12.5l2.5 2.5L16 9.5" />
                </svg>
                <span className="pm-toast__status">Рейс подтверждён</span>
                <button className="pm-toast__close" type="button" aria-label="Закрыть" onClick={dismiss}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#6b7280"
                        strokeWidth="2"
                        strokeLinecap="round"
                        aria-hidden="true"
                    >
                        <path d="M6 6l12 12M18 6L6 18" />
                    </svg>
                </button>
            </div>
            <h2 className="pm-toast__title" id="pm-toast-title">
                Заявка и ЭПД — за 1 минуту в Pooling.me
            </h2>
            <p className="pm-toast__text">Без ручного ввода и бумажных оригиналов</p>
            <div className="pm-toast__actions">
                <a
                    className="pm-toast__cta"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => openEpdUrl(url, e)}
                >
                    Подписать сейчас
                </a>
                <button className="pm-toast__later" type="button" onClick={dismiss}>
                    Позже
                </button>
            </div>
        </div>
    );
};
